import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alm-timeline-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlmTimelineComponent = _resolveComponent("AlmTimelineComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentChangeset?.detail, (tenant) => {
      return (_openBlock(), _createBlock(_component_AlmTimelineComponent, {
        key: tenant?.id,
        currentTenant: tenant
      }, null, 8, ["currentTenant"]))
    }), 128))
  ]))
}